import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';
import { AdminLayoutComponent } from './admin/layout/admin-layout/admin-layout.component';
import { LoginComponent } from './ui/components/login/login.component';
import { AuthGuard } from './guards/common/auth.guard';

import { FooterComponent } from './admin/layout/admin-layout/components/footer/footer.component';
import { SyllabusScreenComponent } from './admin/components/yoklama/ders-programi/syllabus-screen.component';
import { HocaDersProgramiComponent } from './admin/components/yoklama/hoca-ders-programi/hoca-ders-programi.component';
import { TeacherCourseComponent } from './admin/components/yoklama/ders-baslat/teacher-course.component';
import { WelcomeComponent } from './admin/components/yoklama/welcome/welcome.component';
import { DeviceManagementComponent } from './admin/components/yoklama/cihaz-yonetimi/device-management.component';
import { DeviceVerificationComponent } from './admin/components/yoklama/cihaz-yonetimi/cihaz-ekle/device-verification.component';
import { StudentAttendanceComponent } from './admin/components/yoklama/derse-katil/student-attendance.component';
import { FeedbackComponent } from './admin/components/yoklama/feedback/feedback.component';
import { KvkkGuard } from './guards/common/kvkk.quard';
import { environment } from 'environments/environment.prod';
import { YuklemeComponent } from './ui/components/yukleme/yukleme.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
{
    path: 'web-app-yukle',
    component: YuklemeComponent,
  },

{
        path: '',
        redirectTo: 'welcome?version=' + environment.version,
        pathMatch: 'full',

      },

  {
    path: '',
    component: AdminLayoutComponent,


    children: [

      {
        path: 'welcome',
        component: WelcomeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'ders-programi',
        component: SyllabusScreenComponent,
        canActivate: [AuthGuard, KvkkGuard],
      },
      {
        path: 'hoca-ders-programi',
        component: HocaDersProgramiComponent,
        canActivate: [AuthGuard, KvkkGuard],
      },
      {
        path: 'ders-yoklama-baslat',
        component: TeacherCourseComponent,
        canActivate: [AuthGuard, KvkkGuard],
      },
      {
        path: 'cihaz-yonetimi',
        component: DeviceManagementComponent,
        canActivate: [AuthGuard, KvkkGuard],
      },

      {
        path: 'device-verification/:deviceId',
        component: DeviceVerificationComponent,
        canActivate: [AuthGuard, KvkkGuard],
      },
      {
        path: 'derse-katil',
        component: StudentAttendanceComponent,
        canActivate: [AuthGuard, KvkkGuard],
      },
      {
        path: 'geribildirim',
        component: FeedbackComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'welcome',
  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes)],
})
export class AppRoutingModule {}
